.gray, .blue, .darkgreen, .lightgreen, .yellow, .orange, .red, .lightblue {
	max-width: 10px;
	max-height: 10px;
}

.gray {
    color: var(--hps-gray);
}

.blue {
    color: var(--hps-blue);
}

.darkgreen {
    color: var(--hps-dark-green);
}

.lightgreen {
    color: var(--hps-light-green);
}

.yellow {
    color: var(--hps-yellow);
}

.orange {
    color: var(--hps-orange);
}

.red {
    color:  var(--hps-red);
}

.lightblue {
    color:  var(--hps-light-blue);
}